/*
 * Copyright 2022 Siemens
 */

import React from 'react';
import {Communication} from '../services/communication';
import {Content} from '../common/content';
import {Information} from '../common/information';
import {CommandBar} from '../common/commandbar';
import App from '../App';
import {SwwcCommandButton} from '@com.siemens.plm.horizon/swwc/bindings/react/src/index';
import {Settings} from '../services/settings';

interface MeState {
  isLoading: boolean;
  item: Record<string, unknown> | null;
}

export class Me extends React.Component<{}, MeState> {
  readonly #map = {};

  constructor(props: {}, state: MeState) {
    super(props, state);
    this.state = {isLoading: true, item: null};
  }

  override componentDidMount() {
    if (super.componentDidMount) super.componentDidMount();
    this.#reloadData(true);
  }

  #reloadData(skipLoadingUpdate?: true): void {
    if (skipLoadingUpdate === undefined) this.setState({isLoading: true});
    Communication.fetch('me', 'GET', 'json+object').then(
      (value) => {
        if (value.status === 'ok' && value.data !== null)
          this.setState({isLoading: false, item: value.data as Record<string, unknown>});
        else if (value.status === 'ok') App.toast('warn', 'User information', undefined, `Data of 'me' is invalid`);
        else
          App.toast(
            'error',
            'User information',
            undefined,
            `Loading of 'me' failed: ${
              ('error' in value && value.error.message) ||
              `[Code: ${value.code}] ${('data' in value && value.data) || 'Unknown'}`
            }`,
          );
      },
      (err) => {
        App.toast(
          'error',
          'User information',
          undefined,
          `Loading of 'me' failed: ${(err instanceof Error && err.message) || err}`,
        );
      },
    );
  }

  override render() {
    return (
      <Content
        section='User information'
        isLoading={this.state.isLoading}
      >
        <CommandBar reloadCommand={() => this.#reloadData()}>
          {Settings.configuration.auth && (
            <SwwcCommandButton
              icon='cmdSignout16'
              label='Logout'
              onClickEvent={() => {
                if (Settings.configuration.auth === false) window.location.reload();
                else window.location.href = Settings.configuration.auth.logout;
              }}
            />
          )}
        </CommandBar>
        <Information
          item={this.state.item}
          map={this.#map}
        />
      </Content>
    );
  }
}
